import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { StripeManualCardPaymentComponent } from './stripe-manual-card-payment.component';
import { SalonMonsterLoadMaskModule } from '../../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterSmallCheckMarkLoaderModule } from '../../../components/smr-small-checkmark-loader/smr-small-checkmark-loader.module';
import { MaskitoModule } from '@maskito/angular';

@NgModule({
  declarations: [
    StripeManualCardPaymentComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterSmallCheckMarkLoaderModule,
    MaskitoModule
  ]
})
export class StripeManualCardPaymentComponentModule {}
